import Box from '@mui/material/Box';

interface FileTypeBadgeProps {
  type: string;
  /** Renders a smaller badge for dense / compact layouts. */
  compact?: boolean;
}

const FILE_TYPE_CONFIG: Record<string, { label: string; color: string }> = {
  img: { label: 'IMG', color: '#64b5f6' },
  pdf: { label: 'PDF', color: '#e57373' },
  xlsx: { label: 'XLSX', color: '#81c784' },
  zip: { label: 'ZIP', color: '#ba68c8' },
  json: { label: 'JSON', color: '#ffb74d' },
  txt: { label: 'TXT', color: '#90a4ae' },
  doc: { label: 'DOC', color: '#7986cb' },
  dwg: { label: 'DWG', color: '#4dd0e1' },
  video: { label: 'VIDEO', color: '#f06292' },
  audio: { label: 'AUDIO', color: '#4db6ac' },
  file: { label: 'FILE', color: '#b0bec5' },
};

// The default badge is a content-width rectangle; the compact badge is a fixed
// square so it reads as a neat, centered tile inside dense attachment pills.
const BADGE_DEFAULT = { px: 1, py: 0.5, fontSize: 12 };
const BADGE_COMPACT_SIZE = 3; // square side, in theme spacing units
const BADGE_COMPACT_FONT_SIZE = 9;

export const FileTypeBadge = ({ type, compact = false }: FileTypeBadgeProps) => {
  const ext = type.toLowerCase();
  const { label, color } = FILE_TYPE_CONFIG[ext] ?? {
    label: ext.toUpperCase(),
    color: '#90a4ae',
  };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        overflow: 'hidden',
        bgcolor: color,
        color: 'white',
        fontWeight: 600,
        lineHeight: 1,
        textTransform: 'uppercase',
        borderRadius: 0.5,
        ...(compact
          ? {
              width: (theme) => theme.spacing(BADGE_COMPACT_SIZE),
              height: (theme) => theme.spacing(BADGE_COMPACT_SIZE),
              fontSize: BADGE_COMPACT_FONT_SIZE,
            }
          : {
              minWidth: 0,
              px: BADGE_DEFAULT.px,
              py: BADGE_DEFAULT.py,
              fontSize: BADGE_DEFAULT.fontSize,
            }),
      }}
    >
      {label}
    </Box>
  );
};
